module.exports = __webpack_public_path__ + "media/styles/images/svg/circle-right-arrow-teal-on-white-edd19b2bbc51616fcc1bda4a6a5d573f.svg";